import { number, bool, oneOfType, string } from "prop-types";
import TriangleExclamationSolidV6 from "@shared/v2/Icomoon/Icons/TriangleExclamationSolidV6";
import ArrowTrendUpSolidV6 from "@shared/v2/Icomoon/Icons/ArrowTrendUpSolidV6";
import { useTheme } from "../../../reducers/layoutReducer/selectors";

const ResultsBanner = ({ isToggleON, homeValueReportCount, totalLeads, count, isCreate, country }) => {
  const isPlaceTheme = useTheme().name === "place-theme";
  return (
    <div className="tw-my-[24px] tw-relative tw-rounded-8px ">
      <div
        className={`tw-absolute tw--inset-2px tw-rounded-8px ${isPlaceTheme ? "tw-bg-[linear-gradient(90deg,#3270FA,#2454B2)]" : "tw-bg-[linear-gradient(90deg,#59C4C4,#336E7B)]"}`}
      />
      <div className="tw-absolute tw-inset-0 tw-bg-white tw-rounded-8px"></div>
      <div className="tw-relative tw-p-[14px] tw-z-10">
        <div className="tw-flex tw-justify-between tw-pb-[8px]">
          <div className="tw-text-[28px] tw-leading-[32px] tw-font-normal tw-text-gray-75">
            {count}
            <span className="tw-pl-[8px] tw-text-[14px] tw-font-normal tw-leading-[20px] tw-text-gray-75">
              {count === 1 ? "report" : "reports"} will be {isCreate ? "created" : "updated"}
            </span>
          </div>
          <div>
            <div className="tw-text-[12px] tw-leading-[16px] tw-font-normal tw-text-gray-50">
              {Number(totalLeads) === Number(count) ? (
                <>
                  {isCreate
                    ? `All ${count} contacts can receive reports`
                    : `All ${count} contacts have at least 1 report`}
                </>
              ) : (
                <>
                  <div className="tw-text-semantic-yellow-120 tw-bg-semantic-yellow-5 tw-rounded-[4px]">
                    <div className="tw-py-[4px] tw-px-[8px] tw-flex tw-items-center">
                      <TriangleExclamationSolidV6 size="m" />
                      <span className="tw-pl-[6px]">
                        {Number(totalLeads) - Number(count)} / {totalLeads} contacts{" "}
                        {isCreate ? "missing info or outside MLS" : "have no reports"}
                      </span>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="tw-text-[12px] tw-leading-[16px] tw-font-normal tw-text-gray-50">
          {isCreate ? (
            <>
              <hr className="tw-border-2 tw-pb-[8px] tw-w-full tw-m-0 tw-border-gray-10" />
              {isToggleON && (
                <div className="tw-pb-[8px] tw-text-[14px] tw-font-normal tw-leading-[20px] tw-text-gray-75">
                  <ArrowTrendUpSolidV6 size="m" />
                  <span className="tw-pl-[6px]">
                    {homeValueReportCount} Market Reports will include a Home Value
                  </span>
                </div>
              )}
              Contacts must have a valid email and be located within your MLS. Market reports require either a
              zip/postal code or city and state/province to generate an accurate report.{" "}
              {country && country !== "canada" && "Home value reports also require a valid street address."}
            </>
          ) : (
            <>
              <span className="tw-font-bold">All</span> reports for{" "}
              <span className="tw-font-bold">every</span> selected contact with at least 1 report will be
              updated
            </>
          )}
        </div>
      </div>
    </div>
  );
};
ResultsBanner.propTypes = {
  totalLeads: oneOfType([number, string]),
  count: oneOfType([number, string]),
  homeValueReportCount: oneOfType([number, string]),
  isCreate: bool,
  isToggleON: bool,
  country: string,
};

ResultsBanner.defaultProps = {
  totalLeads: 0,
  count: 0,
  isCreate: false,
  isToggleON: false,
  homeValueReportCount: 0,
  country: "",
};
export default ResultsBanner;
